import React, {useEffect, useState} from 'react';
import {
  Button,
  Switch,
  FormControlLabel,
  FormGroup,
  Container,
  Grid,
  Stack,
  Box,
  Card,
  CardContent,
  Chip,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Tooltip
} from '@mui/material';
import AssessmentStepper from './Assessment/AddTeat';
import {useOnlineContext} from '../ModulePageComponents/AdditionData/OnlineTestContext';
import {getErrorMessage} from '@shared/utils/ErrorUtils';
import EncryptUtils from 'src/utils/EncryptUtils';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
  getLMSResultsData,
  getSearchForm
} from '@shared/services/service-handlers/PrivateService';
import {useAppContext} from '@context/AppContext';
import {enqueueSnackbar} from 'notistack';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import {useLocation, useNavigate} from 'react-router-dom';
import {LoadingScreen} from 'src/minimal-components/loading-screen';
import {LoadingButton} from '@mui/lab';
import {
  BASE_RECORD_ID,
  BASE_ROUTE,
  BASE_ROUTE_MODULE,
  BASE_UNIQUE_ID,
  LMS_IS_ADMIN,
  LMS_MODULE_ID,
  LMS_TYPE,
  MOVE_TO_TAB,
  PARAMS_KEY
} from 'src/routes/BaseRoute';
import ComputerIcon from '@mui/icons-material/Computer';
import FormConstants from '@shared/constants/FormConstants';
import {useBoolean} from 'src/hooks/use-boolean';
import {ConfirmDialog} from '@components/custom-dialog';
import {MoreVert} from '@mui/icons-material';

interface AssignMembersProps {
  uiFieldsData: any;
}
const PreLearningActivities = ({
  uiFieldsData
}: AssignMembersProps): React.ReactElement => {
  const {
    appState: {applicationName}
  } = useAppContext();
  function useQuery() {
    const {search} = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }
  const query = useQuery();
  const uniqueId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_RECORD_ID
  );

  const confirm = useBoolean();
  const [dialogOpen, setDialogOpen] = useState(false);
  const {onlineData, setOnlineData} = useOnlineContext();
  const {uiFields, setUiFields} = useOnlineContext();
  const {questionsData, setQuestionData} = useOnlineContext();
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [editmodule, setEditModule] = useState(false);
  const [mainScreenSaving, SetMainScreenSaving] = useState<boolean>(false);
  const [isEnabled, setIsEnabled] = useState(
    onlineData?.isPreLearningTestEnabled || false
  );
  // const [isMandatory, setIsMandatory] = useState(
  //   onlineData?.isPreLearningTestMandatory || false
  // );
  const [onlineLoader, setOnlineLoader] = useState<boolean>(true);
  const lmstype = EncryptUtils.getDecryptedData(location?.search, LMS_TYPE);
  const section = query.get('section');
  const subSection = query.get('subsection');
  const lmsisAdmin = EncryptUtils.getDecryptedData(
    location?.search,
    LMS_IS_ADMIN
  );

  const fileId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_UNIQUE_ID
  );
  const moduleId = EncryptUtils.getDecryptedData(
    location?.search,
    LMS_MODULE_ID
  );
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);

  // console.log(
  //   'onRoleChange1',
  //   uniqueId,
  //   fileId,
  //   moduleId,
  //   lmstype,
  //   section,
  //   subSection,
  //   isEnabled
  // );

  const navigate = useNavigate();
  const handleMenuOpen = (
    event: React.MouseEvent<HTMLElement>,
    moduleId: string
  ) => {
    setMenuAnchor(event.currentTarget);
  };
  // const handleSnackbarClose = () => {
  //   setOpenSnackbar(false);
  // };
  const onRoleChange = async () => {
    //console.log('onRoleChange1', uniqueId, fileId, moduleId, onlineData);

    const paramsKey = EncryptUtils.setEncryptedParams({
      [BASE_RECORD_ID]: uniqueId,
      [LMS_TYPE]: lmstype,
      [LMS_IS_ADMIN]: lmsisAdmin,
      [MOVE_TO_TAB]: 'pre_learning_activities',
      [BASE_UNIQUE_ID]: onlineData?.inserted_id,
      [LMS_MODULE_ID]: onlineData?.module_id
    });
    navigate(
      `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.COURSE_CATALOG}/OnlineTest?${PARAMS_KEY}=${paramsKey}`,
      {
        state: {}
      }
    );
  };
  const onDelete = async () => {
    try {
      //console.log('delete');
      setDeleteLoading(true);
      const operations = 'DELETE';
      const {sql_data} = uiFields['create_sql'];
      const data: any = {
        sql_data: sql_data,
        data: {
          overview_id: uniqueId,
          course_overview_id: uniqueId,
          id: onlineData.inserted_id || onlineData.id
        },
        operation: operations
      };
      //console.log('data', data, onlineData);
      const encryptRequestData = EncryptUtils.encryptedData(data);
      const result = await getLMSResultsData(applicationName, 'LMS', {
        tk: encryptRequestData
      });
      //console.log('result', result, result.data[0]);
      setOnlineData(result.data[0]);
      setQuestionData([]);
      setDeleteLoading(false);
    } catch (e) {
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
      setDeleteLoading(false);
    }
  };
  const init = async () => {
    try {
      setOnlineLoader(true);
      let res = uiFieldsData;
      if (uiFieldsData === null || uiFieldsData === undefined) {
        res = await getSearchForm(applicationName, 'settings', 'Prelearning');
        await setUiFields(res.searchForm);
      } else {
        setUiFields(uiFieldsData.searchForm);
      }
      if (res?.searchForm || uiFieldsData?.searchForm) {
        const {sql_data} =
          uiFieldsData?.searchForm['create_sql'] || res.searchForm['create_sql'];
        const operations = 'SEARCH';
        const data: any = {
          sql_data: sql_data,
          data: {course_overview_id: uniqueId, overview_id: uniqueId,isAdmin: lmsisAdmin === 'True' ? true : false},
          operation: operations
        };
        //console.log('data', data);
        const encryptRequestData = EncryptUtils.encryptedData(data);
        const result = await getLMSResultsData(applicationName, 'LMS', {
          tk: encryptRequestData
        });
        await setIsEnabled(result.data[0]?.isPreLearningTestEnabled);
        // await setIsMandatory(result.data[0]?.isPreLearningTestMandatory);
        // console.log(
        //   'result.data[0]',
        //   result.data[0],
        //   result.data[0].inserted_id
        // );
        const transformedResults = result.data.map((item: any) => {
          return {
            ...item,
            // Parse JSON fields or set them to empty arrays if they are null
            ipRestrictions: item.ipRestrictions
              ? JSON.parse(item.ipRestrictions)
              : null
            // Add any additional transformations here if needed
          };
        });
        setOnlineData(transformedResults[0]);
        const datas: any = {
          sql_data: sql_data,
          data: {
            course_overview_id: result.data[0].inserted_id || uniqueId,
            overview_id: result.data[0].inserted_id,
            isAdmin: lmsisAdmin === 'True' ? true : false
          },
          operation: 'QUESTIONSEARCH'
        };
        const encryptRequestDatas = EncryptUtils.encryptedData(datas);
        const results = await getLMSResultsData(applicationName, 'LMS', {
          tk: encryptRequestDatas
        });
        const transformedResult = results.data.map((item: any) => {
          return {
            ...item,
            // Parse JSON fields or set them to empty arrays if they are null
            choices: item.choices ? JSON.parse(item.choices) : null,
            correctMatches: item.correctMatches
              ? JSON.parse(item.correctMatches)
              : null,
            additionalChoices: item.additionalChoices
              ? JSON.parse(item.additionalChoices)
              : null,
            descriptive_enforce_word_limit: item.descriptive_enforce_word_limit
              ? JSON.parse(item.descriptive_enforce_word_limit)
                  .descriptive_enforce_word_limit
              : null,
            // Parse the descriptive_enforce_word_limit_length JSON or set it to null
            descriptive_enforce_word_limit_length:
              item.descriptive_enforce_word_limit_length
                ? JSON.parse(item.descriptive_enforce_word_limit_length)
                    .descriptive_enforce_word_limit_length
                : null,
            TrueFalse: item.TrueFalse
              ? JSON.parse(item.TrueFalse).TrueFalse
              : null
            // Add any additional transformations here if needed
          };
        });
        await setQuestionData(transformedResult);
        // if (result.data[0].assignment_submission_type_id) {
        //   setSubmissionType(result.data[0].assignment_submission_type_id);
        //   setValue(
        //     'SubmissionType',
        //     result.data[0].assignment_submission_type_id
        //   );
        // }

        setOnlineLoader(false);
      }

      setOnlineLoader(false);
    } catch (e) {
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
      setOnlineLoader(false);
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      await init();
    };

    fetchData();
  }, []);
  const handleSave = async () => {
    try {
      SetMainScreenSaving(true);
      const {sql_data} = uiFields['create_sql'];
      const operations = 'UPDATEMAINSCREEN';
      const data: any = {
        sql_data: sql_data,
        data: {
          id: uniqueId,
          course_overview_id: uniqueId,
          isPreLearningTestEnabled: isEnabled
        },
        operation: operations
      };
      const encryptRequestData = EncryptUtils.encryptedData(data);
      const result = await getLMSResultsData(applicationName, 'LMS', {
        tk: encryptRequestData
      });
      // if (result.data[0].assignment_submission_type_id) {
      //   setSubmissionType(result.data[0].assignment_submission_type_id);
      //   setValue(
      //     'SubmissionType',
      //     result.data[0].assignment_submission_type_id
      //   );
      // }

      SetMainScreenSaving(false);
    } catch (e) {
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
      SetMainScreenSaving(false);
    }
  };
  const handleEnableChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsEnabled(event.target.checked);
  };
  // const handleMandatoryChange = (
  //   event: React.ChangeEvent<HTMLInputElement>
  // ) => {
  //   setIsMandatory(event.target.checked);
  // };

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    // init()
    setDialogOpen(false);
    setEditModule(false);
  };

  return onlineLoader ? (
    <Stack
      display={'flex'}
      justifyContent={'center'}
      alignItems={'center'}
      minHeight={'50vh'}>
      <LoadingScreen />
    </Stack>
  ) : (
    <>
      <Container
        sx={{
          backgroundColor: 'white',
          borderRadius: '8px',
          maxWidth: '100% !important',
          py: '3vh'
        }}>
        <Grid
          container
          spacing={2}
          sx={{margin: '0 !important', width: '100% !important'}}>
          <h3>Pre Learning Activities</h3>
        </Grid>
        <FormGroup>
          <Grid item xs={12} sx={{margin: '2vh 0'}}>
            <FormControlLabel
              sx={{marginButtom: '1vh'}}
              control={
                <Switch checked={isEnabled} onChange={handleEnableChange} color='success'/>
              }
              label="Enable Test"
            />
            <p style={{paddingBottom: '1vh'}}>
              This test is to evaluate the learner`s proficiency before starting
              the course
            </p>
            {onlineData && (onlineData.inserted_id || onlineData.id) && (
              <Box sx={{mx: 2, p: 2}}>
                <Card
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    p: 2,
                    boxShadow:
                      isEnabled &&
                      '8px 10px 9px 0px rgba(145, 158, 171, 0.2), 0px 2px 2px 0px rgba(145, 158, 171, 0.14), 0px 1px 5px 0px rgba(145, 158, 171, 0.12)',
                    borderRadius: 2,
                    bgcolor: isEnabled ? 'white' : '#d9d9d9'
                  }}>
                  {/* Left Icon Section */}
                  <Box
                    sx={{
                      bgcolor: isEnabled ? '#FFF7DD' : '#f1f1f1',
                      p: 2,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: 2,
                      mr: 2,
                      width: 64,
                      height: 64
                    }}>
                    <ComputerIcon sx={{fontSize: 32, color: '#FBC02D'}} />
                  </Box>

                  {/* Content Section */}
                  <CardContent
                    onClick={() => {
                      // if (isEnabled) {
                      //   handleOpenDialog();
                      // }
                    }}
                    sx={{
                      flexGrow: 1,
                      p: 0,
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      cursor: isEnabled ? 'pointer' : 'cursor'
                    }}>
                    <Typography variant="h6" sx={{fontWeight: 'bold'}}>
                      {onlineData.name}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      Questions: {questionsData.length} • Marks:{' '}
                      {questionsData.reduce(
                        (acc: any, q: {QuestionMarks_id: any}) =>
                          acc + q.QuestionMarks_id,
                        0
                      )}{' '}
                      • Duration:
                      {onlineData?.assessment_time_limit_type_id === 1
                        ? onlineData?.overallTime_in_minutes
                        : onlineData?.assessment_time_limit_type_id === 2
                          ? onlineData.time_per_question_in_minutes *
                            questionsData.length
                          : 'No Time Limit'}
                    </Typography>
                  </CardContent>

                  {/* Right Actions Section */}
                  <Box
                    sx={{
                      alignItems: 'center',
                      flexDirection: 'column',
                      gap: 1
                    }}>
                    {onlineData?.Publish ? (
                      <Chip
                        label="PUBLISHED"
                        color="success"
                        size="small"
                        sx={{fontWeight: 'bold'}}
                      />
                    ) : (
                      <Chip
                        label="DRAFT"
                        color="info"
                        size="small"
                        sx={{fontWeight: 'bold'}}
                      />
                    )}
                    {onlineData?.Publish === null ||
                    onlineData?.Publish == false ? (
                      <IconButton
                        size="small"
                        disabled={!isEnabled}
                        onClick={event => {
                          handleMenuOpen(event, module.id);
                        }}>
                        <MoreVert />
                      </IconButton>
                    ) : (
                      <Tooltip title="Preview">
                        <span>
                          <IconButton
                            size="small"
                            disabled={!isEnabled}
                            onClick={event => {
                              onRoleChange();
                            }}>
                            <VisibilityIcon />
                          </IconButton>
                        </span>
                      </Tooltip>
                    )}

                    {/* Dropdown Menu */}
                    <Menu
                      anchorEl={menuAnchor}
                      open={Boolean(menuAnchor)}
                      onClose={() => setMenuAnchor(null)}>
                      {(onlineData?.Publish === null ||
                        onlineData?.Publish == false) && (
                        <MenuItem
                          onClick={e => {
                            setMenuAnchor(null);
                            setEditModule(true);
                            handleOpenDialog();
                          }}>
                          Edit
                        </MenuItem>
                      )}
                      <MenuItem
                        onClick={e => {
                          setMenuAnchor(null);
                          onRoleChange();
                        }}>
                        Preview
                      </MenuItem>
                      {(onlineData?.Publish === null ||
                        onlineData?.Publish == false) && (
                        <MenuItem
                          onClick={e => {
                            setMenuAnchor(null);
                            confirm.onTrue();
                          }}>
                          Delete
                        </MenuItem>
                      )}
                    </Menu>
                  </Box>
                </Card>
              </Box>
            )}
            <Grid item xs={12} sx={{display: 'inline-grid'}}>
              {(onlineData?.name === undefined ||
                onlineData?.inserted_id === undefined ||
                onlineData?.name === null ||
                onlineData?.inserted_id === null) && (
                <Button
                  sx={{
                    marginLeft: '5vh',
                    maxWidth: 'max-content',
                    marginBottom: '1vh '
                  }}
                  variant="outlined"
                  disabled={!isEnabled}
                  onClick={handleOpenDialog}>
                  Add Test +
                </Button>
              )}
              {/* <FormControlLabel
                sx={{marginLeft: '5vh', maxWidth: 'max-content'}}
                control={
                  <Switch
                    checked={isMandatory}
                    onChange={handleMandatoryChange}
                  />
                }
                label="Mandatory"
                disabled={!isEnabled}
              /> */}
            </Grid>
          </Grid>
        </FormGroup>
        <LoadingButton
          loading={mainScreenSaving}
          variant="contained"
          color="primary"
          onClick={handleSave}
          style={{marginTop: '20px'}}>
          Save
        </LoadingButton>
      </Container>
      <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="Delete"
        content="Are you sure want to delete?"
        action={
          <LoadingButton
            variant="contained"
            color="error"
            loading={deleteLoading}
            onClick={() => {
              onDelete();
              confirm.onFalse();
            }}>
            Delete
          </LoadingButton>
        }
      />
      {dialogOpen && (
        <Container
          sx={{
            backgroundColor: 'white',
            borderRadius: '8px',
            maxWidth: '100% !important',
            py: '3vh',
            marginTop: '2vh'
          }}>
          {' '}
          <AssessmentStepper onClose={handleCloseDialog} />
        </Container>
      )}
    </>
  );
};

export default PreLearningActivities;
